// Angular imports
import { Injectable } from '@angular/core';

// CC-Common imports
import { Utils } from 'cc-common';
import { HelperService } from '../../_services/shared-services/helper.service';

@Injectable({
    providedIn: 'root'
})
export class CirabooksHelperService {
    constructor(private readonly helperService: HelperService) {}

    // ANG-2602: Refactor the code for subcategory validation based on Gl Account label selection for
    /**
     * Get the display text for the selected account.
     */
    getAccountDisplayText(
        selectedAccountType: string,
        rawItem: any,
        glAccountLabelSource: any[],
        glAccountNumberSource: any[]
    ): string {
        if (Utils.equalsIgnoreCase(selectedAccountType, 'account_label')) {
            const selectedAccountLabel = glAccountLabelSource.find((d) =>
                Utils.equalsIgnoreCase(d.code, rawItem.accountLabelCode)
            );
            return Utils.notNullAndDefined(selectedAccountLabel)
                ? `${selectedAccountLabel.title}`
                : rawItem.accountLabelCode;
        } else {
            const selectedGLAccount = glAccountNumberSource.find((d) =>
                Utils.equals(d.glAccountNumber, rawItem.glAccountNumber)
            );
            return Utils.notNullAndDefined(selectedGLAccount) ? selectedGLAccount.displayText : rawItem.glAccountNumber;
        }
    }

    /**
     * Process subcategories.
     */
    processSubcategories(
        rawItem: any, // cellInfo, selected Cell value.. it could be GLAccountLabel or GLAccountNumber
        subcategorySource: any[],
        existingLineItemSubcategoryCode: string, // has value only when editing the lineItem
        selectedAccountType: string, // get selected account display text
        glAccountLabelSource: any[],
        glAccountNumberSource: any[]
    ): { rawItem: any; infoMessage: string | null } {
        rawItem.subCategorySource = subcategorySource;

        const selectedAccountDisplayText = this.getAccountDisplayText(
            selectedAccountType,
            rawItem,
            glAccountLabelSource,
            glAccountNumberSource
        );

        // existing line item with previously selected subcategory
        if (Utils.notNullAndDefined(existingLineItemSubcategoryCode)) {
            // This block will execute only in case of edit lineitem.
            // rawItem.subcategoryCode is same as existingLineItemSubcategoryCode only in case of edit
            const selectedSubCategory = rawItem.subCategorySource.find((d) =>
                Utils.equalsIgnoreCase(d.code, existingLineItemSubcategoryCode)
            );
            if (Utils.isNullOrUndefined(selectedSubCategory)) {
                // selectedSubcateogry is not in the list
                /*
                    ANG-2553: As discussed and confirmed with Sandeep on 11/11/24, if subcategory is not available in dataSource, show information to user
                */
                rawItem.subCategoryCode = null;
                rawItem.isAccountSubcategoryValid = false;
                rawItem.accountSubcategoryValidationMessage = `Subcategory "${existingLineItemSubcategoryCode}" for "${selectedAccountDisplayText}" is not active.<br>Please work with the Community CiraBooks Accounting team to update the community configuration.`;
                return { rawItem, infoMessage: rawItem.accountSubcategoryValidationMessage };
            } else {
                rawItem.isAccountSubcategoryValid = true;
                rawItem.accountSubcategoryValidationMessage = null;
                return { rawItem, infoMessage: null };
            }
        }

        // new line item or existing line item without subcategory
        let rawItemSubCategory = null;
        // Null check for glAccountNumber is not required as we expect glAccountNumber to always be present
        const selectedGLAccount = glAccountNumberSource.find((d) =>
            Utils.equals(d.glAccountNumber, rawItem.glAccountNumber)
        );
        if (Utils.isNullOrUndefined(selectedGLAccount)) {
            /*
                ANG-2553: As discussed and confirmed with Sandeep on 11/11/24, If GL account itself not active, show information to user
            */
            rawItem.subCategoryCode = null;
            rawItem.isAccountSubcategoryValid = false;
            rawItem.accountSubcategoryValidationMessage = `GL Account Number ${rawItem.glAccountNumber} is not active".<br>Please work with the Community CiraBooks Accounting team to update the community configuration.`;
            return { rawItem, infoMessage: rawItem.accountSubcategoryValidationMessage };
        }

        if (Utils.isTrue(selectedGLAccount.requiresSubCategory)) {
            if (Utils.isNullOrEmpty(subcategorySource)) {
                // If subcategories are empty display error for subcategory not configured
                rawItem.subCategoryCode = null;
                rawItem.isAccountSubcategoryValid = false;
                rawItem.accountSubcategoryValidationMessage = `Subcategories are not configured for "${selectedGLAccount.glAccountNumber}".<br>Please work with the Community CiraBooks Accounting team to update the community configuration.`;
                return { rawItem, infoMessage: rawItem.accountSubcategoryValidationMessage };
            } else {
                // corresponding subcategory item from Subcategory Source
                rawItemSubCategory = subcategorySource.find((d) =>
                    Utils.equalsIgnoreCase(d.code, rawItem.subCategoryCode)
                );
            }

            if (Utils.isNullOrUndefined(rawItemSubCategory)) {
                if (Utils.equalsIgnoreCase(selectedAccountType, 'account_label')) {
                    if (Utils.notNullOrEmpty(rawItem.subCategoryCode)) {
                        // If GL account is active and requires subcategory is true and selectedAccountLabel has default subcategory
                        rawItem.isAccountSubcategoryValid = false;
                        rawItem.accountSubcategoryValidationMessage = `Subcategory is required and ${rawItem.subCategoryCode} is not active for "${selectedAccountDisplayText}".<br>Please work with the Community CiraBooks Accounting team to update the community configuration.`;
                        rawItem.subCategoryCode = null;
                        return { rawItem, infoMessage: rawItem.accountSubcategoryValidationMessage };
                    } else {
                        // If entityUsesSubCategory is true and subcategory is not configured for GL Account
                        rawItem.subCategoryCode = null;
                        rawItem.isAccountSubcategoryValid = false;
                        rawItem.accountSubcategoryValidationMessage = `Subcategory is required and is not configured for "${selectedAccountDisplayText}".<br>Please work with the Community CiraBooks Accounting team to update the community configuration.`;
                        return { rawItem, infoMessage: rawItem.accountSubcategoryValidationMessage };
                    }
                } else {
                    // In case of GL account Number .. nothing to check return isAccountSubcategoryValid as true as subcategory dropdown will not be disable in this case
                    rawItem.isAccountSubcategoryValid = true;
                    return { rawItem, infoMessage: null };
                }
            } else {
                // nothing to do, valid case
                rawItem.isAccountSubcategoryValid = true;
                return { rawItem, infoMessage: null };
            }
        } else {
            //  In case of GL account Label and GL account number .. Since GL account Number does not require subcategory
            if (Utils.notNullOrEmpty(subcategorySource)) {
                rawItemSubCategory = subcategorySource.find((d) =>
                    Utils.equalsIgnoreCase(d.code, rawItem.subCategoryCode)
                );

                if (Utils.equalsIgnoreCase(selectedAccountType, 'account_label')) {
                    if (Utils.isNullOrUndefined(rawItemSubCategory) && Utils.notNullOrEmpty(rawItem.subCategoryCode)) {
                        // If GL account is active and requires subcategory is false and selectedAccountLabel has default subcategory which is not active
                        const messageToInform = `Subcategory ${rawItem.subCategoryCode} is not active for "${selectedAccountDisplayText}".<br>Please work with the Community CiraBooks Accounting team to update the community configuration.`;
                        const dialog = this.helperService.getOkDialog('Information', messageToInform);
                        dialog.show();
                        rawItem.isAccountSubcategoryValid = true;
                        rawItem.subCategoryCode = null;
                        return { rawItem, infoMessage: null };
                    }
                }
            }

            rawItem.isAccountSubcategoryValid = true;
            rawItem.subCategoryCode = Utils.notNullAndDefined(rawItemSubCategory) ? rawItemSubCategory.code : null;
            return { rawItem, infoMessage: null };
        }
    }
}
